
import React from 'react'
import { Tabs, Checkbox, message } from 'antd';
import Config from "../../config/Config";
import WidgetAjax from '../../widget/WidgetAjax';
import Appraisal from './appraisal';
import Favorite from './favorite';
let path = Config.getBasePath();
let filePath = Config.getFilePath();

class messageCenter extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      menuList: [
        { label: '我的测评', key: '1' },
        { label: '我的收藏', key: '2' }
      ],
      tabValue: '1',
      data: [],
    }
  }
  async componentDidMount() {
    this.getUserInfo();

  }

  componentWillUnmount() {

  }

  getUserInfo = () => {
    const onUserInfo = (res) => {
      if (res.status == 0) {
        this.setState({ user: res.result });
      }
    }
    WidgetAjax.ajax({ url: path + '/applicant/resume_info', params: {}, callback: onUserInfo });

  }


  tabonChange = (value) => {
    this.setState({ tabValue: value });
  }

  render() {
    const { menuList, tabValue } = this.state;

    return <div component-data="planning">
      <div className='screen'>
        <div className='head_filter'>
          <div className='box_1200'>
            <div className='head_title'>我的职业规划</div>
          </div>
        </div>

        <div className='mes_box box_1200' style={{ paddingTop: "104px" }}>
          <div className='mes_menu'>
            <Tabs items={menuList} value={tabValue} onChange={this.tabonChange} tabPosition={'right'} />
          </div>

          <div className='account_setting_box'>

            {
              tabValue === '1' ?
                <Appraisal history={this.props.history} />
                :
                <Favorite history={this.props.history} />
            }

          </div>


        </div>
      </div>

    </div>
  }
}

export default messageCenter;